<template>
  <div>
    <Header></Header>
    <div class="first-floor">
      <div class="banner">
        <img :src="imgUrls">
        <div v-if="ENVIRON_MENT === 'ja'" class="txt">静安消防蓝盾网欢迎您！</div>
        <div v-else class="txt"><span>{{ text }}</span>智慧消防欢迎您！</div>
        <div class="text">
          <div class="pt">
            <span>物联服务商</span>
            <p class="yello">接入系统</p>
            <a @click="opennew">
              <button style="background: #d3ae2d; cursor: pointer;">
                进入
              </button>
            </a>
          </div>
          <div class="pt">
            <span>建筑管理单位</span>
            <p v-if="ENVIRON_MENT === 'hp'">备案系统</p>
            <p v-else class="green">履责系统</p>
            <a @click="opennew2">
              <button style="background: #83d32d; cursor: pointer;">
                进入
              </button>
            </a>
          </div>
          <div class="pt">
            <span>维保单位</span>
            <p class="red">备案系统</p>
            <a @click="opennew3">
              <button style="background: #e65e54; cursor: pointer;">
                进入
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="third-floor">
      <div>
        <div class="ewm" v-show="isShow === 1">
          <!-- <dl>
            <dt class="center"><img src="../../assets/images/er.png" alt=""></dt>
            <dd class="center">打开微信扫一扫</dd>
            <dd class="center">关注群防群治公众号</dd>
          </dl> -->
          <img :src='imgUrl' alt="">
          <div style="font-size: 14px">打开微信扫一扫</div>
          <div style="font-size: 14px">关注群防群治公众号</div>
        </div>
        <h2>
          <span style="cursor: pointer;">最新通知与公告</span>
          <router-link to="notice">
            <span style="color: #003A8B">
              更多 >
            </span>
          </router-link>
        </h2>
      </div>
      <ul>
        <li
          v-for="(item,index) in listsdata"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="fl" style="cursor: pointer;">
            <p class="notice">{{textspical(item.title)}} <img v-show="index==0" src="../../assets/xk.png"></p>
            <span class="title">{{item.desc}}</span>
          </div>
          <div class="fr" style="cursor: pointer;">
            <p class="time">{{ item.updatetime ? dayjs(item.updatetime*1000).format('YYYY-MM-DD') : dayjs(item.createtime*1000).format('YYYY-MM-DD') }}</p>
            <span class="page">浏览量 {{item.view_num == null ? 0:item.view_num}}次</span>
          </div>
        </li>
      </ul>
      <div v-if="tipMessage" style="text-align: center; color: #4989CC">
        <i class="el-icon-warning-outline" />
        {{ tipMessage }}
      </div>
    </div>
    <div class="ss">
      <img src="../../assets/images/ss.png" alt>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/basicComponents/header'
import Footer from '@/components/basicComponents/footer'
// import axios from 'axios'
import dayjs from 'dayjs'
import { announcements, settingList, improveList } from '@/api/gov'
import updown from '@/components/basicComponents/updown'
export default {
  components: {Header, Footer, updown},
  data () {
    return {
      dayjs,
      url: '',
      url2: '',
      url3: '',
      imgUrls: '',
      tipMessage: '',
      text: '静安区',
      listsdatas: {
        page: 1,
        page_size: 5,
        filter: '',
        order: 'sort asc'
      },
      listQuery: {
        _page: 1,
        _limit: 5,
        flag: 1,
        _search: 'is_publish,flag',
        _sort: 'sort',
        is_publish: 1
      },
      listsdata: {},
      isShow: 1,
      imgUrl: '',
      ENVIRON_MENT: process.env.ENV_SERVER
    }
  },
  created () {
    if (this.ENVIRON_MENT === 'demo') {
      this.text = '上海'
      localStorage.setItem('text', this.text)
      this.imgUrls = require('@/assets/images/bgsh.png')
    } else if (this.ENVIRON_MENT === 'sh') {
      this.text = '上海'
      this.imgUrls = require('@/assets/images/bgsh.png')
      localStorage.setItem('text', this.text)
    } else if (this.ENVIRON_MENT === 'ja') {
      this.text = '静安区'
      this.imgUrls = require('@/assets/images/bg.png')
      localStorage.setItem('text', this.text)
    } else if (this.ENVIRON_MENT === 'hp' || this.ENVIRON_MENT === 'hpnw') {
      this.text = '黄浦区'
      this.imgUrls = require('@/assets/images/bghp.png')
      localStorage.setItem('text', this.text)
    } else {
      this.text = '上海'
      this.imgUrls = require('@/assets/images/bgsh.png')
      localStorage.setItem('text', this.text)
    }
    settingList().then(res => {
      if (res.code === 0) {
        const data = res.data
        const val = JSON.parse(data.val)
        this.isShow = parseInt(val.publicnoinform_notice)
        // process.env.BASE_API
        this.imgUrl = process.env.BASE_API + '/common/file/getfile?fileid=' + val.publicnoinform_img
        console.log('data', val)
        console.log('imgUrl', this.imgUrl)
      } else {
        this.isShow = 0
      }
    }).catch(err => {
      this.$message.error(err)
    })
  },
  mounted () {
    // this.announcement()
    this.getList()
  },
  methods: {
    getList () {
      improveList(this.listQuery).then(res => {
        if (res.data.data.length === 0) {
          this.tipMessage = '暂无信息'
        } else {
          this.listsdata = res.data.data
        }
      })
    },
    textspical (text) {
      const ftext = text.replace(/&#34;/g, '"')
      return ftext
    },
    goDetail (item) {
      // console.log('listsdata', val.id)
      // this.$router.push({ name: 'particulars',
      //   params: { id: val.id }})
      if (item.data_type === 1) {
        this.$router.push({name: 'particulars', params: { list: item, id: item.id }})
      } else if (item.data_type === 0) {
        this.$router.push({name: 'improvedetails', params: { id: item.id }})
      }
    },
    opennew () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT)
      } else {
        window.open(process.env.BASE_AGENTCLIENT)
      }
    },
    opennew2 () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT2)
      } else {
        window.open(process.env.BASE_AGENTCLIENT2)
      }
    },
    opennew3 () {
      if (process.env.ENV_SERVER === 'demo') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'sh') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'ja') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else if (process.env.ENV_SERVER === 'hp' || process.env.ENV_SERVER === 'hpnw') {
        window.open(process.env.BASE_AGENTCLIENT3)
      } else {
        window.open(process.env.BASE_AGENTCLIENT3)
      }
    },
    announcement () {
      const obj = {
        _page: this.listsdatas.page,
        _limit: this.listsdatas.page_size,
        order: this.listsdatas.order,
        _search: 'is_publish',
        is_publish: 1
      }
      announcements(obj).then(res => {
        console.log('resres', res)
        if (res.data.data.length === 0) {
          this.tipMessage = '暂无信息'
        } else {
          this.listsdata = res.data.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../style/commints.less";
.icon{
  position: absolute;
  font-size:20px;
  color:#47607e;
  right:15px;
  font-weight: 600;
  top:15px;
}
.ewm {
  text-align: center;
  position: absolute;
  top: 18%;
  left: 14%;
}
.ewm img{
  width: 100px;
  height: 100px;
}
.first-floor {
  margin-top: -60px;
  width: 100%;
  box-sizing: border-box;
  .banner {
    position: relative;
    img {
      width: 100%;
      height: 426px;
      position: relative;
      top: 60px;
    }
    .text {
      width: 80%;
      height: 48px;
      position: absolute;
      left: 60%;
      bottom: 8%;
      transform: translateX(-50%);
      color: #ffffff;
      .pt {
        bottom: 50%;
        top: 0.3%;
        transform: translateX(-50%);
        text-align: center;
        display: inline-block;
        margin-left: 9%;
        width: 18%;
      }
      span {
        width: 100%;
        font-size: 18px;
        display: block;
      }
      p {
        margin: 0;
        padding: 0;
        padding-bottom: 8px;
        font-size: 30px;
        display: inline-block;
      }
    }
  }
  button {
    padding: 0 20px;
    width: 125px;
    height: 24px;
    border-radius: 20px;
    border: none;
    background-color: #fff;
    color:#fff;
    font-weight: 700;
    text-align: center;
    .el-icon-right {
      float: right;
      font-size: 16px;
    }
  }
  .fr {
    position: absolute;
    right: 0;
  }
}
.second-floor {
  margin-top: -5px;
  width: 100%;
  height: 577px;
  .banner {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 577px;
    }
    .text {
      padding: 10px;
      box-sizing: border-box;
      position: absolute;
      left: 20%;
      top: 10%;
      h1 {
        font-size: 22px;
        font-weight: 400;
        font-family: "SourceHanSansCN-Regular";
        color: rgba(30, 56, 84, 1);
      }
      p {
        margin-top: 5%;
        width: 60%;
        margin-bottom: 5%;
        color: rgba(30, 56, 84, 1);
        font-family: "SourceHanSansCN-Regular";
        font-size: 11px;
      }
      a {
        font-size: 12px;
        color: #ff0000;
      }
    }
  }
}
.third-floor {
  width: 100%;
  // padding: 0 10%;
  padding: 0 25% 10%;
  box-sizing: border-box;
  /*overflow: hidden;*/
  position: relative;
  ul {
    margin-bottom: 80px;
    li {
      position: relative;
      border-bottom: 1px solid #b0b0b0;
      .fl {
        width: 85%;
        p {
          font-size: 18px;
          margin-bottom: 5px;
        }
        span {
          line-height: 20px;
          font-size: 12px;
          display: inline-block;
          // width: 85% !important;
          padding-bottom: 10px;
        }
      }
      .fr {
        float: right;
        margin-right: 3%;
        position: absolute;
        right: -10px;
        top: -10px;
        p {
          font-size: 12px;
          margin-bottom: 10px;
        }
        span {
          font-size: 10px;
        }
      }
    }
  }
  h2 {
    width: 100%;
    font-weight: normal;
    font-size: 26px;
    color: #2d2d2d;
    margin-left: 3%;
    margin-top: 130px;
    margin-bottom: 60px;
    a {
      position: absolute;
      right: 25%;
      font-size: 12px;
      line-height: 40px;
    }
  }
  .left {
    width: 100%;
    float: left;
    @media screen and (max-width: 475px) {
      .div {
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        h2 {
          margin-top: 5px;
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .first-floor {
    .banner {
      .text {
        display: flex;
        position: absolute;
        top: 60%;
        transform: translateX(-50%);
        width: 100%;
        color: #ffffff;
      }
    }
    .txt {
      display: block;
      position: absolute;
      left: 50%;
      top: 65%;
      transform: translateX(-50%) translateY(-50%);
      width: 400px;
      color: #fff;
      font-size: 50px !important;
      letter-spacing: 5px;
      text-align: center;
    }
    .pt {
      width: 30% !important;
      margin-left: 40px !important;
      span {
        font-size: 14px;
      }
      p {
        font-size: 26px !important;
      }
      .el-icon-right {
        line-height: 30px !important;
      }
    }
    .text {
      display: none !important;
    }
  }
  .third-floor {
    padding: 10%;
    padding-left: 0;
    h2 {
      font-weight: normal;
      padding-left: 7%;
      a {
        right: 7%;
      }
    }
    .fr {
      display: none;
    }
    .ewm {
      display: none;
    }
    ul {
      li {
        .fl {
          .notice {
            font-size: 20px !important;
          }
          .title {
            font-size: 16px !important;
          }
        }
      }
      .img {
        position: absolute;
        top: 1%;
        right: 10%;
        img {
          width: 50px;
          height: 22px;
          position: relative;
          top: 16px;
          left: 15px;
        }
        span {
          position: relative;
          z-index: 111;
          top: 14px;
          left: -16px;
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }
  .ss img {
    opacity: 0.3;
  }
}
.img {
  position: absolute;
  top: 0;
  right: 20%;
  img {
    width: 25px;
    height: 14px;
    position: relative;
    top: 16px;
    left: 5px;
  }
  span {
    position: relative;
    z-index: 111;
    top: 14px;
    left: -16px;
    font-size: 10px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basicComponents/home.vue